/**
 * Tipos do Pronto Atendimento.
 * Regra: 1 Schedule + 1 HealthcareService; disponibilidade = Schedule.active.
 */

/** Modos suportados no Pronto Atendimento (remoto = teleatendimento). */
export type ProntoAtendimentoMode = "remoto" | "presencial" | "chat";

/** Status da fila de próximos pacientes. */
export type ProntoAtendimentoQueueStatus = "waiting" | "in_progress";

/** Intervalo HH:mm do dia de hoje (HCS availability). */
export interface ProntoDayTimeInterval {
  start: string;
  end: string;
}

/** Configuração = a única agenda PA do profissional. */
export interface ProntoAtendimentoConfig {
  id: string;
  /** Nome amigável (Schedule.name). */
  label: string;
  mode: ProntoAtendimentoMode;
  /** Valor da consulta em reais (BRL) — extension service-cost. */
  value: number;
  /** Espelho de Schedule.active — disponível para atender agora. */
  active: boolean;
  locationId?: string;
  locationDisplay?: string;
  /** Único HCS vinculado ao Schedule PA. */
  healthcareServiceId?: string;
  healthcareServiceDisplay?: string;
  /** Especialidade escolhida (nome do HCS). */
  specialty?: string;
  /** Compat FHIR (extension default); UI não gerencia múltiplos. */
  isDefault?: boolean;
}

/** Item da lista de próximos pacientes. */
export interface ProntoAtendimentoQueueItem {
  id: string;
  patientName: string;
  /** Horário de chegada/agendamento na fila (exibição). */
  timeLabel: string;
  status: ProntoAtendimentoQueueStatus;
}

/** Paciente selecionado no fluxo "Atender agora". */
export interface ProntoAtendimentoPatientStub {
  id: string;
  name: string;
  cpf?: string;
  isNew?: boolean;
}

export const PRONTO_ATENDIMENTO_MODE_LABELS: Record<
  ProntoAtendimentoMode,
  string
> = {
  remoto: "Remoto",
  presencial: "Presencial",
  chat: "Chat",
};

/** Input de upsert da única configuração (+ HCS do dia). */
export interface ProntoAtendimentoConfigInput {
  mode: ProntoAtendimentoMode;
  value: number;
  /** Especialidade do profissional logado → name do HCS. */
  specialty: string;
  /** Intervalos de disponibilidade só do dia de hoje.
   * PA: sempre 1 jornada contínua (sem divisão de turnos). */
  todayIntervals: ProntoDayTimeInterval[];
  /** Se true, garante Schedule.active = true após salvar. */
  activate?: boolean;
  /** Presencial: Location existente. */
  selectedLocationId?: string;
  /** Presencial: criar nova Location. */
  newLocation?: {
    name: string;
    city?: string;
    state?: string;
    cep?: string;
    street?: string;
    number?: string;
    complement?: string;
  };
}
